import React, {useState} from 'react';
import Image from 'gatsby-image'
import styled from 'styled-components'
import Zoom from 'react-reveal/Zoom';
import { Link } from "gatsby"

const SectionStyle = styled.div`    
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;        
`;

const BackPopUp = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba( 255, 255, 255, .5 );
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;
  cursor: pointer;
  h4{
    color: #ff5c3e;
    font-size: 1.4em;
    text-align: center;
  }
  @media (min-width: 768px) {
    h4{
      text-align: left;
    }
  }
`;

const PopUpStyle = styled.div`
  background-color: transparent;
  padding: 1em;
  width: 70vw;    
  margin: auto;
  z-index: 9999;
  
  @media (min-width: 768px) {
    padding: 0em;
    width: 30vw;    
  }
`;

const CloseStyle = styled.div`
text-align: right;
  span{
      position: relative;
      top: 3em;
      right: 1em;
      padding: 1em;
      background-color: #ffffff;
      color: #000000;
      font-weight: bold;
      z-index: 99999;
  }
`;


const Popup = ({popup, linkPopup}) => {
    const [ popUp, setpopUp] = useState(true);
    return ( 
        <SectionStyle>
{
                popUp ? 
                        <>
                            <BackPopUp onClick={()=> setpopUp(false)}>
                                <Zoom>
                                    <PopUpStyle>
                                        <CloseStyle  onClick={()=> setpopUp(false)}>
                                            <span>X</span>
                                        </CloseStyle>     
                                        <Link to={linkPopup} target="_blank" rel="noreferrer">
                                            <Image fluid={popup.fluid}/>
                                        </Link>      
                                    </PopUpStyle>
                                </Zoom>
                            </BackPopUp>
                        </>
                    : null
                }
        </SectionStyle>
     );
}
 
export default Popup;
